import { useQuery } from '@tanstack/react-query';
import { useSearchParams } from 'react-router-dom';

import API from 'configs/API';
import { axiosGet } from 'utils/apis/axios';

const useNewArrivals = (userUuid) => {
  const [searchParams] = useSearchParams();
  const objectParamsFromSearchParams = Object.fromEntries(searchParams);

  const params = {
    ...objectParamsFromSearchParams,
    user_uuid: String(userUuid || ''),
  };

  return useQuery({
    queryKey: [API.ARTWORK.ARTWORK_NEW_ARRIVAL, params],
    queryFn: async ({ queryKey }) => {
      const [url, p] = queryKey;
      const qs = new URLSearchParams(p).toString();
      const { data } = await axiosGet(false, `${url}?${qs}`);
      return data;
    },
  });
};

export default useNewArrivals;
